import React, { useEffect, useRef } from 'react'
import { useContext } from 'react'
import { HubConnectionBuilder, HttpTransportType } from "@microsoft/signalr";

const urlLocal = "localhost:7101"
const urlNotebook = "192.168.114.83:7101"
const urlServer = "agpisaga.azurewebsites.net"
const urlTest = "agpisaga-dev.azurewebsites.net"

export const WsEvents = {
    NewWagon: 'NEW_WAGON',
    UpdateWagon: 'UPDATE_WAGON',
    BlockedWagon: 'BLOCKED_WAGON',
    ReleasedWagon: 'RELEASED_WAGON',
    EntryWagon: 'ENTRY_WAGON',
    CurvadWagon: 'CURVAD_WAGON',
    FinisheddWagon: 'FINISHED_WAGON',
    ApproveddWagon: 'APPROVED_WAGON',
}

const WsContext = React.createContext()

export default function WebsocketContext({ children }) {

    const socket = useRef({})
    const handlers = useRef({})

    const connect = () => {
        // TODO
        //const token = JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : '';

        socket.current = new HubConnectionBuilder()
            .withUrl(`https://${urlTest}/WebSocket`, {
                skipNegotiation: true,
                transport: HttpTransportType.WebSockets,
            })
            .withAutomaticReconnect()
            .build();

        try {
            socket.current.start().then(() => {
                socket.current.on("ReceiveMessage", (message) => {
                    handleMessage(message);
                });
            });
        } catch (err) {
            console.log(err);
        }
    }


    useEffect(() => {
        connect();
    }, [])

    const handleMessage = (message) => {
        for (let event in handlers.current) {
            let eventType = message
            let eventHandlerType = event.split(':')[0]

            if (eventHandlerType === eventType)
                handlers.current[event]()
        }
    }

    const sendMessage = async (message) => {
        await socket.current.invoke("SendAsync", message);
    };

    const setHandler = (event, origin, handlerFn) => {
        handlers.current[`${event}:${origin}`] = handlerFn
    }

    return <WsContext.Provider value={{
        setHandler: setHandler,
        sendMessage: sendMessage
    }}>
        {children}
    </WsContext.Provider>
}

export function useWebsocket() {
    return useContext(WsContext)
}